"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DockParameter = void 0;
var Location_1 = require("../../rmf_fleet_msgs/msg/Location");
var DockParameter = /** @class */ (function () {
    function DockParameter(fields) {
        if (fields === void 0) { fields = {}; }
        this.start = fields.start || '';
        this.finish = fields.finish || '';
        this.path = fields.path || [];
    }
    DockParameter.validate = function (obj) {
        var e_1, _a;
        if (typeof obj['start'] !== 'string') {
            throw new Error('expected "start" to be "string"');
        }
        if (typeof obj['finish'] !== 'string') {
            throw new Error('expected "finish" to be "string"');
        }
        if (!Array.isArray(obj['path'])) {
            throw new Error('expected "path" to be an array');
        }
        try {
            for (var _b = __values(obj['path'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    Location_1.Location.validate(v);
                }
                catch (e) {
                    throw new Error("in index ".concat(i, " of \"path\":\n  ") + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    DockParameter.FullTypeName = 'rmf_fleet_msgs/msg/DockParameter';
    return DockParameter;
}());
exports.DockParameter = DockParameter;
/*
# The name of the waypoint where the docking begins
string start

# The name of the waypoint where the docking ends
string finish

# The points in the docking path
Location[] path
*/
